/** 单位换算与 A4 常量。业务数据一律使用毫米，仅在渲染/导出边界换算。 */

export const PT_PER_MM = 72 / 25.4;
export const MM_PER_PT = 25.4 / 72;
export const PX_PER_MM_AT_96DPI = 96 / 25.4;

export const A4 = {
  widthMm: 210,
  heightMm: 297,
} as const;

/** 打印安全边距（不假设无边距打印）。 */
export const PRINT_MARGIN_MM = 10;

/** 可打印区域尺寸（mm）。 */
export const PRINTABLE = {
  widthMm: A4.widthMm - PRINT_MARGIN_MM * 2,
  heightMm: A4.heightMm - PRINT_MARGIN_MM * 2,
} as const;

/** 50 mm 校验条长度，规格书第 7.3 节要求精确复现。 */
export const SCALE_BAR_MM = 50;

export const mmToPt = (mm: number): number => mm * PT_PER_MM;
export const ptToMm = (pt: number): number => pt * MM_PER_PT;
export const mmToPx = (mm: number, pxPerMm: number): number => mm * pxPerMm;

export const clamp = (v: number, min: number, max: number): number =>
  v < min ? min : v > max ? max : v;

export const roundMm = (mm: number): number => Math.round(mm * 1000) / 1000;

export const toRad = (deg: number): number => (deg * Math.PI) / 180;
export const toDeg = (rad: number): number => (rad * 180) / Math.PI;

/** 单精度容差：几何比较统一使用，避免浮点噪声导致布尔运算抖动。 */
export const EPS_MM = 1e-6;
export const EPS_ANGLE = 1e-9;
